import React from "react";
import { useTranslation } from "react-i18next";
import { SimpleGrid, Stack, Text, Title } from "@mantine/core";
import {
  IconCloud,
  IconCoin,
  IconDatabase,
  IconShield,
  IconTableImport,
} from "@tabler/icons";
import MigrationProviderCard from "./MigrationProviderCard";

export const MIGRATION_PROVIDERS = [
  {
    id: "inspal",
    name: "Inspal",
    description:
      "Upload Inspal exports, preview mapped data, generate MBID templates, and import in dependency order.",
    status: "active",
    path: "inspal",
    icon: IconDatabase,
  },
  {
    id: "abagile",
    name: "ABAgile",
    description: "Import data from ABAgile broker system.",
    status: "coming_soon",
    icon: IconCloud,
  },
  {
    id: "beefintech",
    name: "BeeFintech",
    description: "Import data from BeeFintech broker system.",
    status: "coming_soon",
    icon: IconCoin,
  },
  {
    id: "insurnet",
    name: "Insurnet",
    description: "Import data from Insurnet broker system.",
    status: "coming_soon",
    icon: IconShield,
  },
  {
    id: "custom",
    name: "Custom Data",
    description:
      "Download MBID import templates and upload filled spreadsheets for each entity in dependency order.",
    status: "active",
    path: "custom",
    icon: IconTableImport,
  },
];

const DataMigrationHub = () => {
  const { t } = useTranslation();

  return (
    <Stack spacing="md">
      <Title order={3}>{t("Data Migration")}</Title>
      <Text size="sm" color="dimmed">
        {t(
          "Choose a source system to import data into MBID. Complete each provider flow in the recommended step order."
        )}
      </Text>

      <SimpleGrid
        cols={3}
        spacing="lg"
        breakpoints={[
          { maxWidth: "lg", cols: 2 },
          { maxWidth: "sm", cols: 1 },
        ]}
        mt="md"
      >
        {MIGRATION_PROVIDERS.map((provider) => (
          <MigrationProviderCard key={provider.id} provider={provider} />
        ))}
      </SimpleGrid>
    </Stack>
  );
};

export default DataMigrationHub;
